import filter from 'lodash/filter';
import map from 'lodash/map';
import includes from 'lodash/includes';
import intersection from 'lodash/intersection';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type IMerchant, IMerchantsFilter } from '../../models/IMerchant';
import { fetchMerchants } from '../ActionCreators';
import toLower from 'lodash/toLower';

interface IMerchantsState {
	merchants: IMerchant[];
	filteredMerchants: IMerchant[];
	isLoading: boolean;
	error: string;
}
const initialState: IMerchantsState = {
	merchants: [],
	filteredMerchants: [],
	isLoading: false,
	error: null,
};

export const merchantsSlice = createSlice({
	name: 'merchants',
	initialState,
	reducers: {
		filterMerchants: (state, action: PayloadAction<Partial<IMerchantsFilter>>) => {
			const filterByCategory = () => {
				if (action.payload.category.id === 0) {
					return state.merchants;
				} else if (action.payload.categories.length > 0) {
					return filter(state.merchants, m => includes(map(action.payload.categories, c => c.id), m.category_id));
				} else {
					return filter(state.merchants, m => m.category_id === action.payload.category.id);
				}
			};

			const filteredByCategory = filterByCategory();

			const filteredByName = action.payload.searchString === ''
				? state.merchants
				: filter(state.merchants, m => includes(toLower(m.name), toLower(action.payload.searchString)));

			state.filteredMerchants = intersection(filteredByCategory, filteredByName);
		}
	},
	extraReducers: {
		[fetchMerchants.fulfilled.type]: (state, action: PayloadAction<IMerchant[]>) => {
			state.isLoading = false;
			state.error = null;
			state.merchants = action.payload;
			state.filteredMerchants = action.payload;
		},
		[fetchMerchants.pending.type]: (state) => {
			state.isLoading = true;
		},
		[fetchMerchants.rejected.type]: (state, action: PayloadAction<string>) => {
			state.isLoading = false;
			state.error = action.payload;
		}
	},
});

export const { filterMerchants } = merchantsSlice.actions;
export default merchantsSlice.reducer;
